import { render, staticRenderFns } from "./LogoAnimation.vue?vue&type=template&id=2cd1ce22"
import script from "./LogoAnimation.vue?vue&type=script&lang=js"
export * from "./LogoAnimation.vue?vue&type=script&lang=js"
import style0 from "./LogoAnimation.vue?vue&type=style&index=0&id=2cd1ce22&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports